import { MediaForum, Topic } from "./topic.model";
import { UserForum } from "./user.model";

export class Comment {
  constructor(
    public id: string = "",
    public comment: string = "",
    public created?: Date | string,
    public updated?: Date | string,
    public authorUser: UserForum = new UserForum(),
    public media?: MediaForum,
    public likeAmount: number = 0,
    public reply?: Reply,
    public userLiked?: boolean,
    public topic?: Topic,
    public userAuthor? :UserForum  
  ) {}
}
export class Reply {
  constructor(
    public id: string = "",
    public comment: string = "",
    public created: Date | string,
    public updated: Date | string,
    public deleteAt: Date | string,
    public authorComment: UserForum = new UserForum(),
    public media: MediaForum,
    public likeAmount: number,
    public userLiked: boolean,
    public topic: Topic
  ) { }
}
export class CommentForm {
  constructor(
    public comment: string = "",
    public mediaId?: string,

  ) { }
}

